// Memory data for the anniversary website - Updated with 8 sections
export const memories = [
  {
    id: 'marriage-certificate',
    slug: 'marriage-certificate',
    title: 'The Quiet Before Forever',
    subtitle: 'Marriage Certificate',
    date: 'February 2025',
    location: 'Home',
    shortDescription: 'The day before the wedding — calm, intimate, and quietly powerful.',
    description: `The day before the wedding — calm, intimate, and quietly powerful.
    
Signing our marriage certificate wasn't about the big celebration. It was about the promise. Just us, knowing that tomorrow our lives would officially become one.

It felt surreal. One signature. One commitment. One forever.`,
    personalNote: 'I remember looking at you and thinking, "This is it. She\'s my wife."',
    images: [
      '/images/IMG-20250221-WA0025.jpg',
      '/images/IMG-20250221-WA0027.jpg',
      '/images/IMG-20250221-WA0028.jpg',
      '/images/IMG-20250221-WA0029.jpg',
    ],
    heroImage: '/images/IMG-20250221-WA0025.jpg',
  },
  {
    id: 'wedding-day',
    slug: 'wedding-day',
    title: 'The Best Day of My Life',
    subtitle: 'Wedding Day',
    date: '22 February 2025',
    location: 'Our Venue',
    shortDescription: 'The day everything changed — and yet felt exactly right.',
    description: `The day everything changed — and yet felt exactly right.

Seeing you walk toward me was a moment frozen in time. The laughter, the vows, the speeches, the dancing — every second felt like magic.

Surrounded by everyone we love, we promised forever.`,
    personalNote: 'Every moment of that day is etched in my memory forever.',
    images: [
      '/images/wedding-day/IMG-20250223-WA0094.jpg',
      '/images/wedding-day/IMG-20250223-WA0096.jpg',
      '/images/wedding-day/IMG-20250223-WA0120.jpg',
      '/images/wedding-day/IMG-20250224-WA0023.jpg',
      '/images/wedding-day/IMG-20250224-WA0123.jpg',
      '/images/wedding-day/IMG-20250224-WA0133.jpg',
      '/images/wedding-day/IMG-20250225-WA0013.jpg',
      '/images/wedding-day/IMG-20250404-WA0252.jpg',
      '/images/wedding-day/IMG-20250404-WA0266.jpg',
      '/images/wedding-day/IMG-20250404-WA0288.jpg',
      '/images/wedding-day/IMG-20250404-WA0294.jpg',
      '/images/wedding-day/IMG-20250404-WA0324.jpg',
      '/images/wedding-day/IMG-20250404-WA0325.jpg',
      '/images/wedding-day/IMG-20250404-WA0330.jpg',
      '/images/wedding-day/IMG-20250404-WA0341.jpg',
      '/images/wedding-day/IMG-20250404-WA0342.jpg',
      '/images/wedding-day/IMG-20250404-WA0354.jpg',
      '/images/wedding-day/IMG-20250404-WA0363.jpg',
      '/images/wedding-day/IMG-20250404-WA0380.jpg',
      '/images/wedding-day/IMG-20250404-WA0381.jpg',
    ],
    heroImage: '/images/wedding-day/IMG-20250223-WA0094.jpg',
  },
  {
    id: 'pe-honeymoon',
    slug: 'pe-honeymoon',
    title: 'Our First Adventure as Husband and Wife',
    subtitle: 'PE Honeymoon',
    date: 'March 2025',
    location: 'Port Elizabeth',
    shortDescription: 'Our honeymoon in PE was the beginning of our married adventures.',
    description: `Our honeymoon in PE was the beginning of our married adventures.

Sunsets, ocean air, quiet mornings, and the excitement of starting a new chapter together.

It wasn't just a trip — it was our first memory as Mr & Mrs.`,
    personalNote: 'Waking up next to you with the sound of the ocean was pure bliss.',
    images: [
      '/images/pe-honeymoon/IMG-20250224-WA0153.jpg',
      '/images/pe-honeymoon/IMG-20250224-WA0176.jpg',
      '/images/pe-honeymoon/IMG-20250224-WA0178.jpg',
      '/images/pe-honeymoon/IMG-20250224-WA0179.jpg',
      '/images/pe-honeymoon/IMG-20250224-WA0187.jpg',
      '/images/pe-honeymoon/IMG-20250224-WA0195.jpg',
      '/images/pe-honeymoon/IMG-20250224-WA0197.jpg',
      '/images/pe-honeymoon/IMG-20250224-WA0199.jpg',
      '/images/pe-honeymoon/IMG-20250224-WA0238.jpg',
      '/images/pe-honeymoon/IMG-20250224-WA0239.jpg',
      '/images/pe-honeymoon/IMG-20250224-WA0240.jpg',
      '/images/pe-honeymoon/IMG-20250224-WA0242.jpg',
    ],
    heroImage: '/images/pe-honeymoon/IMG-20250224-WA0195.jpg',
  },
  {
    id: 'exploring-oxford',
    slug: 'exploring-oxford',
    title: 'Wandering Through History',
    subtitle: 'Exploring Oxford',
    date: 'March 2025',
    location: 'Oxford, England',
    shortDescription: 'Oxford felt like stepping into another world.',
    description: `Oxford felt like stepping into another world.

Exploring somewhere so timeless with you made me realize how lucky I am to share my life with you.`,
    personalNote: 'Every city feels better when I\'m holding your hand.',
    images: [
      '/images/exploring-oxford/IMG-20250331-WA0169.jpg',
      '/images/exploring-oxford/IMG-20250331-WA0199.jpg',
      '/images/exploring-oxford/IMG-20250331-WA0200.jpg',
      '/images/exploring-oxford/IMG-20250331-WA0202.jpg',
      '/images/exploring-oxford/IMG-20250331-WA0204.jpg',
      '/images/exploring-oxford/IMG-20250331-WA0207.jpg',
      '/images/exploring-oxford/IMG-20250331-WA0211.jpg',
      '/images/exploring-oxford/IMG-20250331-WA0214.jpg',
      '/images/exploring-oxford/IMG-20250331-WA0224.jpg',
    ],
    heroImage: '/images/exploring-oxford/IMG-20250331-WA0200.jpg',
  },
  {
    id: 'six-by-nico',
    slug: 'six-by-nico',
    title: 'A Night of Flavours & Laughter',
    subtitle: 'Six By Nico',
    date: 'May 2025',
    location: 'Restaurant',
    shortDescription: 'Seven courses. Endless smiles.',
    description: `Seven courses. Endless smiles.

Trying something new together, guessing ingredients, laughing at our completely wrong food predictions.

It wasn't just dinner — it was an experience. And like everything else, it was better because it was with you.`,
    personalNote: 'Your laugh across the candlelit table is my favorite sound.',
    courses: [
      'Machu Picchu: Flame Grilled Lamb Skewer',
      'Chichen-Itza: Crouquetas De Aji De Gallina',
      'Temple of Artemis: Cucumber & Barbecue Lettuce Gaspacho',
      'Statue of Zeus: Black Olive Beignet',
      'The Colosseum: Smoked Pork Belly',
      'Christ the Redeemer: Scorched Mackerel',
      'Great Wall of China: Grilled Bass, White Kimchi, XO Sauce'
    ],
    images: [
      '/images/six-by-nico/IMG-20250515-WA0026.jpg',
      '/images/six-by-nico/IMG-20250515-WA0027.jpg',
      '/images/six-by-nico/IMG-20250515-WA0029.jpg',
      '/images/six-by-nico/IMG-20250515-WA0030.jpg',
      '/images/six-by-nico/IMG-20250515-WA0031.jpg',
      '/images/six-by-nico/IMG-20250515-WA0032.jpg',
      '/images/six-by-nico/IMG-20250515-WA0033.jpg',
      '/images/six-by-nico/IMG-20250515-WA0034.jpg',
      '/images/six-by-nico/IMG-20250515-WA0036.jpg',
      '/images/six-by-nico/IMG-20250515-WA0037.jpg',
      '/images/six-by-nico/IMG-20250515-WA0046.jpg',
      '/images/six-by-nico/IMG-20250515-WA0047.jpg',
      '/images/six-by-nico/IMG-20250515-WA0049.jpg',
      '/images/six-by-nico/IMG-20250515-WA0053.jpg',
      '/images/six-by-nico/IMG-20250515-WA0056.jpg',
      '/images/six-by-nico/IMG-20250515-WA0057.jpg',
      '/images/six-by-nico/IMG-20250515-WA0061.jpg',
    ],
    heroImage: '/images/six-by-nico/IMG-20250515-WA0049.jpg',
  },
  {
    id: 'guildford-fest-abba',
    slug: 'guildford-fest-abba',
    title: 'Music, Dancing & Pure Joy',
    subtitle: 'Guildford Fest & Abba',
    date: 'July 2025',
    location: 'Guildford',
    shortDescription: 'A weekend of music, laughter, and dancing like nobody was watching.',
    description: `A weekend of music, laughter, and dancing like nobody was watching.

Guildford Fest and ABBA together — the perfect combination for creating unforgettable memories.

Singing along to every song, holding hands through the crowd, and feeling completely alive.`,
    personalNote: 'Dancing with you to ABBA is a core memory. Cause somewhere in the crowd there\'s you.',
    images: [
      '/images/guildford-fest-abba/IMG-20250705-WA0054.jpg',
      '/images/guildford-fest-abba/IMG-20250705-WA0056.jpg',
      '/images/guildford-fest-abba/IMG-20250705-WA0076.jpg',
      '/images/guildford-fest-abba/IMG-20250705-WA0083.jpg',
      '/images/guildford-fest-abba/IMG-20250705-WA0094.jpg',
      '/images/guildford-fest-abba/IMG-20250705-WA0104.jpg',
      '/images/guildford-fest-abba/IMG-20250706-WA0022.jpg',
      '/images/guildford-fest-abba/IMG-20250712-WA0002.jpg',
      '/images/guildford-fest-abba/IMG-20250712-WA0012.jpg',
      '/images/guildford-fest-abba/IMG-20250712-WA0027.jpg',
      '/images/guildford-fest-abba/IMG-20250712-WA0030.jpg',
      '/images/guildford-fest-abba/IMG-20250712-WA0036.jpg',
      '/images/guildford-fest-abba/IMG-20250715-WA0000.jpg',
      '/images/guildford-fest-abba/IMG-20250715-WA0006.jpg',
    ],
    heroImage: '/images/guildford-fest-abba/IMG-20250705-WA0054.jpg',
  },
  {
    id: 'exploring-turkey',
    slug: 'exploring-turkey',
    title: 'Our Second Honeymoon',
    subtitle: 'Exploring Turkey',
    date: 'October 2025',
    location: 'Turkey',
    shortDescription: 'Turkey was breathtaking — ancient wonders, stunning views, and incredible food.',
    description: `Turkey was breathtaking — ancient wonders, stunning views, and incredible food.

Our second honeymoon felt like a dream. Sunny days on the beach to the historic sites, every moment was magical.

Exploring a new country together, trying new foods, and falling more in love with each adventure.`,
    personalNote: 'Our first big holiday, the best holiday I ever had. Turkey was beautiful.. you were more! PS. I\'m the king of Uno, +4, make it red.',
    images: [
      '/images/exploring-turkey/IMG-20251024-WA0027.jpg',
      '/images/exploring-turkey/IMG-20251024-WA0041.jpg',
      '/images/exploring-turkey/IMG-20251025-WA0010.jpg',
      '/images/exploring-turkey/IMG-20251025-WA0013.jpg',
      '/images/exploring-turkey/IMG-20251025-WA0025.jpg',
      '/images/exploring-turkey/IMG-20251025-WA0033.jpg',
      '/images/exploring-turkey/IMG-20251025-WA0034.jpg',
      '/images/exploring-turkey/IMG-20251030-WA0007.jpg',
      '/images/exploring-turkey/IMG20251024-081129-14.jpg',
      '/images/exploring-turkey/IMG20251024-103322-22.jpg',
    ],
    heroImage: '/images/exploring-turkey/IMG-20251024-WA0027.jpg',
  },
  {
    id: 'december-holiday',
    slug: 'december-holiday',
    title: 'Celebrating the Season Together',
    subtitle: 'December Holiday',
    date: 'December 2025',
    location: 'Home & Family',
    shortDescription: 'Our first December as a married couple — full of warmth, family, and festive cheer.',
    description: `Our first December as a married couple — full of warmth, family, and festive cheer.

The holidays hit different when you're spending them with the love of your life. Every decoration, every meal, every moment felt more special.

From cozy nights in to celebrations with family, this December was everything.`,
    personalNote: 'I would tackle a Hairy Coo for you.',
    images: [
      '/images/december-holiday/IMG-20251216-WA0009.jpg',
      '/images/december-holiday/IMG-20251216-WA0036.jpg',
      '/images/december-holiday/IMG-20251216-WA0040.jpg',
      '/images/december-holiday/IMG-20251216-WA0069.jpg',
      '/images/december-holiday/IMG-20251216-WA0075.jpg',
      '/images/december-holiday/IMG-20251217-WA0051.jpg',
      '/images/december-holiday/IMG-20251217-WA0052.jpg',
      '/images/december-holiday/IMG-20251217-WA0063.jpg',
      '/images/december-holiday/IMG-20251217-WA0080.jpg',
      '/images/december-holiday/IMG-20251217-WA0087.jpg',
      '/images/december-holiday/IMG-20251217-WA0115.jpg',
      '/images/december-holiday/IMG-20251217-WA0118.jpg',
      '/images/december-holiday/IMG-20251217-WA0135.jpg',
      '/images/december-holiday/IMG-20251217-WA0143.jpg',
      '/images/december-holiday/IMG-20251217-WA0163.jpg',
      '/images/december-holiday/IMG-20251217-WA0184.jpg',
      '/images/december-holiday/IMG-20251217-WA0194.jpg',
      '/images/december-holiday/IMG-20251218-WA0113.jpg',
      '/images/december-holiday/IMG-20251218-WA0147.jpg',
      '/images/december-holiday/IMG-20251219-WA0002.jpg',
      '/images/december-holiday/IMG-20251220-WA0085.jpg',
      '/images/december-holiday/IMG-20251220-WA0088.jpg',
      '/images/december-holiday/IMG-20251220-WA0135.jpg',
      '/images/december-holiday/IMG-20251223-WA0088.jpg',
      '/images/december-holiday/IMG-20251223-WA0141.jpg',
      '/images/december-holiday/IMG-20251223-WA0152.jpg',
      '/images/december-holiday/IMG-20251223-WA0278.jpg',
      '/images/december-holiday/IMG-20251227-WA0037.jpg',
      '/images/december-holiday/IMG-20251230-WA0115.jpg',
      '/images/december-holiday/IMG-20260101-WA0106.jpg',
      '/images/december-holiday/IMG-20260103-WA0007.jpg',
      '/images/december-holiday/IMG-20260103-WA0046.jpg',
      '/images/december-holiday/IMG-20260103-WA0067.jpg',
      '/images/december-holiday/IMG-20260105-WA0010.jpg',
      '/images/december-holiday/IMG-20260105-WA0016.jpg',
    ],
    heroImage: '/images/december-holiday/IMG-20251217-WA0087.jpg',
  },
];

export const timeline = [
  {
    year: '2020',
    title: 'First Date',
    description: 'The moment everything began. Coffee turned into hours of conversation.',
  },
  {
    year: '11 Nov 2020',
    title: 'When I Asked You to Be My GF',
    description: 'The day I asked you to be mine, and you said yes.',
  },
  {
    year: '2021',
    title: 'Our First Home Living Together',
    description: 'Belvedere on Thomas Road — close to Cool Runnings. Our first chapter of living together.',
  },
  {
    year: 'Dec 2022',
    title: 'When We Moved to the UK',
    description: 'A new country, a new adventure — together.',
  },
  {
    year: 'Aug 2024',
    title: 'Engagement',
    description: 'I asked, you said yes. The happiest day of my life — until the wedding.',
  },
  {
    year: '22 Feb 2025',
    title: 'Wedding',
    description: 'We said "I do" surrounded by everyone we love.',
  },
  {
    year: 'March 2025',
    title: 'Honeymoon',
    description: 'Our first adventure as husband and wife in Port Elizabeth.',
  },
  {
    year: 'Oct 2025',
    title: 'Second Honeymoon — Turkey',
    description: 'Exploring Turkey together — ancient wonders and new memories.',
  },
  {
    year: 'Feb 2026',
    title: 'First Anniversary',
    description: 'One year down, forever to go.',
  },
];

export const stats = [
  { number: '365', label: 'Days Married' },
  { number: '10', label: 'Cities Explored' },
  { number: '3', label: 'Countries Explored' },
  { number: '∞', label: 'Laughter' },
];
